import * as React from "react"
import type { SVGProps } from "react"
const SvgRec = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M19.79 10.04q.68 0 1.2.52.51.51.51 1.2v1.71q0 .14-.04.32l-.09.32-2.57 6.05a2 2 0 0 1-.64.73q-.45.3-.95.3H7.8V10.04l5.14-5.1q.32-.32.76-.37t.85.16.6.6.08.8l-.96 3.91zm-10.29.73v8.7h7.71l2.58-6v-1.71h-7.72l1.16-4.72zM5.21 21.19a1.7 1.7 0 0 1-1.2-.5 1.7 1.7 0 0 1-.51-1.22v-7.71q0-.71.5-1.21a1.7 1.7 0 0 1 1.21-.5H7.8v1.7H5.2v7.72h2.6v1.72z" />
  </svg>
)
export default SvgRec
